// extracted by mini-css-extract-plugin
export var phoneNumberInput = "_ay-0";